module.exports = __webpack_public_path__ + "img/culture_active1.7461934c.png";